import React from 'react';
import Title from './title';
import LineChart from './line_chart';
import PieChart from './pie_chart';

const App = () =>
  <div id="app">
    <Title />
    <LineChart />
    <PieChart />
    <div className="footer-background">
      <div className="container">
        <div className="footer-block">
          <div className="title">協作資料收集</div>
          <div className="info-paragraph">
            <p className="info">中央銀行 | 銀行間市場新臺幣對美元收盤匯率（資料統計103年1月至105年8月）
              <br />
              <a href="http://data.gov.tw/node/7232">
                http://data.gov.tw/node/7232
              </a>
            </p>
          </div>
          <div className="info-paragraph">
            <p className="info">交通部觀光局 | 來臺旅客人數及成長率－按居住地分（資料統計103年1月至105年8月）
              <br />
              <a href="http://admin.taiwan.net.tw/statistics/month.aspx">http://admin.taiwan.net.tw/statistics/month.aspx</a>
            </p>
          </div>
        </div>
        <div className="footer-block">
          <div className="title">延伸閱讀</div>
          <div className="info-paragraph">
            <p className="info">
              103年1月至7月份整體觀光外匯收入 仍較去年同期增加新臺幣200億元<br />
              <a href="http://taiwan.net.tw/m1.aspx?sNo=0023090" target="_blank">http://taiwan.net.tw/m1.aspx?sNo=0023090</a>
            </p>
          </div>
          <div className="info-paragraph">
            <p className="info">
              交通部觀光局秉持「多元開放、全球布局」理念 來臺旅客總人數持續成長 <br />
              <a href="http://taiwan.net.tw/m1.aspx?sNo=0023089" target="_blank">http://taiwan.net.tw/m1.aspx?sNo=0023089</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>;

App.propTypes = {
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/app.js
 **/